export const additionalTaxTypeApi = (params) => {
    return `/additional-tax-settings?lite=true`;
};